import React from "react";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";
import LangTools from "./LangTools";

const Header = props => {
  return (
    <Translation>
      {t => (
        <div id="header">
          <LangTools />
          <h1>{t("system.project_name")}</h1>
          <div id="header-border"></div>
        </div>
      )}
    </Translation>
  );
};

export default Header;
